import { Pencil, Sparkles, TrendingDown, TrendingUp, type LucideIcon } from 'lucide-react';

import type { HistoryEntryView } from './private-event-history-rows';

export interface IconSpec {
  Icon: LucideIcon;
  bg: string;
  fg: string;
  /** Set only for a headcount change, where the arrow carries meaning. */
  label?: string;
}

const NEUTRAL = { bg: 'var(--nb-surface-2)', fg: 'var(--nb-subtle)' };

/** A trend arrow for a headcount change, a spark for creation and import, a
 *  pencil for any other edit. */
export function iconSpec(entry: HistoryEntryView): IconSpec {
  const headcount = entry.changes.find((c) => c.kind === 'headcount');
  if (headcount?.kind === 'headcount') {
    const up = headcount.delta > 0;
    return {
      Icon: up ? TrendingUp : TrendingDown,
      bg: up ? 'var(--nb-primary-soft)' : 'var(--nb-warn-soft)',
      fg: up ? 'var(--nb-primary-2)' : 'var(--nb-warn)',
      label: `Headcount went ${up ? 'up' : 'down'}`,
    };
  }
  return { Icon: entry.marker ? Sparkles : Pencil, ...NEUTRAL };
}
